import '../../../test.css';
import React, { useCallback, forwardRef } from "react";
import { useSelector } from 'react-redux';
import moment from "moment";
import { getMessageUserName } from 'pages/HistoryPage/HistoryPage.config';
import { messageWithURL } from "utils/functions";

const Transcript = forwardRef(({ transcript, visitorPartner }, ref) => {
  const { partnerTeam } = useSelector(({ agents })=> agents);

  const senderName = useCallback((id) => {
    return getMessageUserName(id, partnerTeam, visitorPartner);
  }, [partnerTeam, visitorPartner]);

  return (
      <div className="transcript-new">
          <span>rating: {transcript.rating || ' -- '}</span>
          <span>Date: {transcript.chatHistory && transcript.chatHistory[0] && moment(new Date(transcript.chatHistory[0].date)).format('DD-MM-YYYY')}</span>
          <div className="messages-new">
              {transcript && transcript.chatHistory && transcript.chatHistory.map((message) => {
                  const isBot = !message.userId;
                  const isVisitor = visitorPartner._id === message.userId;
                  let messageNew = message.message;
                  if(isBot){
                      const [userPartnerId, action] = message.message.split('_');
                      const name = senderName(userPartnerId).name || message.name;
                      messageNew = name + ' ' + action;
                  }
                  const fileType = message.file.split('.').reverse()[0];

                  return (
                      <div className={isBot ? 'log' : isVisitor ? 'visitor' : 'agent'}>
                          {messageNew}
                          {fileType && <>{
                              (fileType === 'mp4' && <video controls="controls" src={message.file} />)
                              || <a href={message.file} target="_blank"><img src={message.file} /></a>
                          }</>}
                          <span>{moment(new Date(message.date)).format('HH:mm:ss')}</span>
                      </div>
                  );
              })}
          </div>
      </div>
  );
});

export { Transcript };
